import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const AuditForm = () => {
  const openGetStarted = () => {
    window.open('https://forms.gle/rU28UfypBujmWmQK9', '_blank');
  };

  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="get-started"
      data-testid="final-cta-section"
      className="py-24 md:py-32 bg-[#1C1917]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#93C5FD] font-semibold text-sm uppercase tracking-wider">
            Get started
          </span>

          <h2
            data-testid="final-cta-headline"
            className="mt-4 font-['DM_Sans'] text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight"
          >
            Your next sale is a{' '}
            <span className="text-[#2563EB]">call away.</span>
          </h2>

          <p className="mt-6 text-base md:text-lg text-[#A8A29E] leading-relaxed max-w-2xl mx-auto">
            Indian D2C brands are losing lakhs to cart abandonment every month. Let's recover
            it — one call, one language, one customer at a time.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Button
              data-testid="final-cta-btn"
              onClick={openGetStarted}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full px-8 py-6 text-lg font-semibold btn-shine group"
            >
              Get 100 free calls
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
            <button
              onClick={scrollToHowItWorks}
              className="text-[#A8A29E] hover:text-white font-medium transition-colors underline underline-offset-4"
            >
              See how it works
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AuditForm;
